const mutation = {
  ROLES_DATA(state, data) {
    state.all = data;
  },

  ROLES_LOADING(state, status) {
    state.isLoading = status;
  },

};

export default mutation;
